import { useState, useEffect } from 'react';

const TUESDAY = 2;
const WEDNESDAY = 3;
const SALES_WEEK_DAYS = [TUESDAY, WEDNESDAY];
const WIX_DISCOUNT_CUSTOMER_GROUP = 'wix_discount';

export type SalesRemainingTime = {
  hours: string;
  minutes: string;
  seconds: string;
};

export type SalesData = {
  isSeasonalSales: boolean;
  endDateTime: Date;
  remainingTimestamp: number;
};

const defaultSalesData: SalesData = {
  isSeasonalSales: false,
  endDateTime: null,
  remainingTimestamp: 0,
};

export const formatRemainingTime = (timestamp: number) => {
  const remainingTimeInSeconds = timestamp;
  const remainingTimeInMinutes = Math.floor(remainingTimeInSeconds / 60);
  const remainingTimeInHours = Math.floor(remainingTimeInMinutes / 60);

  const formattedHours = remainingTimeInHours + '';
  const formattedMinutes = (remainingTimeInMinutes % 60) + '';
  const formattedSeconds = (remainingTimeInSeconds % 60) + '';

  const remainingTime: SalesRemainingTime = {
    hours: (formattedHours.length === 1 ? '0' : '') + formattedHours,
    minutes: (formattedMinutes.length === 1 ? '0' : '') + formattedMinutes,
    seconds: (formattedSeconds.length === 1 ? '0' : '') + formattedSeconds,
  };

  return `${remainingTime.hours}:${remainingTime.minutes}:${remainingTime.seconds}`;
};

const useSeasonalSales = () => {
  const [salesData, setSalesData] = useState<SalesData>(defaultSalesData);

  const getPsdDate = () => {
    const currentDatetime = new Date();

    const pstDatetimeString = currentDatetime.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
    });
    return new Date(pstDatetimeString);
  };

  const getSalesNextEndDate = () => {
    const psdDatetime = getPsdDate();

    if (psdDatetime.getDay() === TUESDAY) {
      psdDatetime.setDate(psdDatetime.getDate() + 2);
    } else if (psdDatetime.getDay() === WEDNESDAY) {
      psdDatetime.setDate(psdDatetime.getDate() + 1);
    }

    psdDatetime.setHours(0);
    psdDatetime.setMinutes(0);
    psdDatetime.setSeconds(0);

    return new Date(psdDatetime);
  };

  const getSalesData = () => {
    const currentPsdDatetime = getPsdDate();

    const currentPstDay = currentPsdDatetime.getDay();

    const remainingTimestamp = Math.floor(
      (getSalesNextEndDate().getTime() - currentPsdDatetime.getTime()) / 1000
    );

    const salesData: SalesData = {
      isSeasonalSales: SALES_WEEK_DAYS.includes(currentPstDay),
      endDateTime: new Date(new Date().getTime() + remainingTimestamp * 1000),
      remainingTimestamp: remainingTimestamp,
    };

    return salesData;
  };

  useEffect(() => {
    try {
      const interval = setInterval(() => {
        if (
          typeof window !== 'undefined' &&
          window.document &&
          // @ts-ignore
          window.document.pcxtV3 !== undefined
        ) {
          clearInterval(interval);

          if (
            // @ts-ignore
            window.document.pcxtV3
              ?.getPricingContext()
              .customerGroups.includes(WIX_DISCOUNT_CUSTOMER_GROUP)
          ) {
            setSalesData(getSalesData());
          }
        }
      }, 100);
    } catch (e) {
      setSalesData(defaultSalesData);
    }
  }, []);

  return salesData;
};

export default useSeasonalSales;
